import HomePage from './components/home/HomePage'

export default function App() {
  return <HomePage lang="tr" />
}
